<div class="utilidex-logo-cont pl-4 ml-1 lt-4 d-none d-sm-block">
  <img src="../../../assets/images/utilidex_logo.png">
</div>
<div class="container login-container">
  <div class="row login-row">
    <div class="heading-cont col-md-5 offset-lg-2 text-white my-auto align-items-center" style="max-width: 565px;">
      <h1 class="heading">Financial Regulation Made Easy</h1>
    </div>
    <div class="col-md-5 col-lg-4 my-auto d-flex align-items-center">
      <div class="col-md-12 mx-auto">
        <!-- form card login -->
        <div class="card" id="login-form">
          <div class="card-header bg-blue">
            Login
          </div>
          <div class="card-body p-0 mt-3">
            <form accept-charset="UTF-8" [formGroup]="loginForm" role="form" #formData='ngForm'>
              <div class="col-auto">
                <label class="sr-only" for="inlineFormInputGroup">Username</label>
                <div class="input-group mb-3">
                  <input class="form-control" type="email" autocomplete="new-Password" placeholder="Email address" name="EmailId"
                    required formControlName="EmailId" [formGroup]="loginForm">
                  <small class="text-danger col-md-12 p-0 mt-2" *ngIf="loginForm.controls['EmailId'].value && !loginForm.controls['EmailId'].valid && loginForm.controls['EmailId'].touched">
                    Please enter a valid email
                  </small>
                  <small class="text-danger col-md-12 p-0 mt-2" *ngIf="!loginForm.controls['EmailId'].value && loginForm.controls['EmailId'].touched">
                    Email is a required field
                  </small>
                </div>
              </div>
              <div class="col-auto">
                <label class="sr-only" for="inlineFormInputGroup">Password</label>
                <div class="input-group mb-2">
                  <input class="form-control" type="password" autocomplete="new-Password" placeholder="Password" name="Password"
                    required formControlName="Password" [formGroup]="loginForm">
                  <small class="text-danger col-md-12 p-0 mt-2" *ngIf="!loginForm.controls['Password'].value && loginForm.controls['Password'].touched">
                    Password is a required field
                  </small>
                </div>
              </div>
              <div class="row m-0 mt-2">
                <div class="col-md-12 mb-2">
                  <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
                </div>
                <small *ngIf="response" class="text-danger col-md-12 mb-2">
                  {{response}}
                </small>
                <div class="col-md-12 col-lg-12">
                  <div class="row">
                    <!-- <div class="col-md-12 col-lg-12 text-right">
                      <label class="custom-checkbox">
                        <a routerLink="/forgot-password/">Forgot Password</a>
                      </label>
                    </div> -->
                    <div class="col-md-12 col-lg-12">
                      <button type="submit" id="login-btn" [disabled]="!loginForm.valid" class="btn btn-sm btn-alt m-0 width-full btn-blue text-white">
                        Sign In
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-lg-12 mb-4">
                  <label class="custom-checkbox mt-2">
                    <a routerLink="/register/">Register</a> If you don't have an
                    account.
                  </label>
                  <label class="custom-checkbox mt-2">
                    <a routerLink="/forgot-password/"><i>Forgot your password?</i></a>
                  </label>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--col-md-12-->
  </div>
  <!--row-->
</div>
<!--continer-->
<app-footer></app-footer>
